import { clsx  } from 'clsx';
import type {ClassValue} from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Concatène des classes Tailwind en résolvant les conflits.
 *
 * `cn('px-4', condition && 'px-6')` renvoie `px-6` : c'est la dernière classe
 * d'une même famille qui gagne, ce que la simple concaténation ne garantit
 * pas. Convention partagée par la quasi-totalité de l'écosystème React +
 * Tailwind.
 */
export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}

/**
 * Retarde l'exécution — utilisé uniquement pour laisser respirer certaines
 * transitions d'écran (par exemple entre la confirmation Stripe et le claim).
 */
export function wait(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Identifiant aléatoire opaque, utilisé comme `Idempotency-Key` sur les
 * tentatives de paiement et comme clé de liste dans l'inspecteur d'API.
 *
 * `crypto.randomUUID` n'est disponible qu'en contexte sécurisé (HTTPS ou
 * localhost) : on retombe sinon sur une génération suffisante pour l'usage.
 */
export function randomId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    return `id-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
}
